import { provideState } from '@ngrx/store';

import { billsharkProvidersFeature } from './billshark-providers.reducer';

export const billsharkProvidersStore = [
  provideState(billsharkProvidersFeature),
];
